<script setup>
import Modal from "@/components/Tools/Modal.vue";
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  showSaveDialog: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(["save", "back", "close"]);

const showDialog = computed({
  get() {
    return props.showSaveDialog;
  },
  set(newValue) {
    if (newValue) {
      return;
    }
    emits("close");
  }
});
</script>

<template>
  <Modal
    :show-modal="showDialog"
    width="500"
    :title="$t('salesChannelManagementApp.saveDialog.title').toString()"
    @toggle-modal="$emit('close')"
  >
    <template #content>
      {{ $t("salesChannelManagementApp.saveDialog.text") }}
    </template>
    <template #footer>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary" @click="$emit('save')">
          {{ $t("salesChannelManagementApp.saveDialog.save") }}
        </button>
        <button class="btn btn-outline-primary ml-2" @click="$emit('back')">
          {{ $t("salesChannelManagementApp.saveDialog.close") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<style scoped lang="scss"></style>
